import angular from 'angular';

class Discounts {
  constructor($log, $http, Endpoints, API_URL, CMS_API_URL) {
    'ngInject';

    Object.assign(this, {
      $log,
      $http,
      Endpoints,
      API_URL,
      CMS_API_URL
    });
  }

  addVisitDiscountByCategoryAndProduct(category_id, product_id, payload) {
    return this.$http.post(this.CMS_API_URL + `/admin/category/` + category_id + `/product/` + product_id + `/visitdiscounts`, payload);
  }

  addVisitDiscountByCategoryAndMedication(category_id, medication_id, payload) {
    return this.$http.post(this.CMS_API_URL + `/admin/category/` + category_id + `/medication/` + medication_id + `/visitdiscounts`, payload);
  }

  updateVisitDiscount(category_promos_xref_id, payload) {
    return this.$http.put(this.CMS_API_URL + `/admin/visitdiscount/` + category_promos_xref_id, payload);
  }

  listVisitDiscount() {
    return this.$http.get(this.CMS_API_URL + `/admin/visitdiscount`, {
      loadingText: `Loading visit discounts`
    });
  }

  addRefillDiscountByCategoryAndMedication(category_id, medication_id, payload) {
    return this.$http.post(this.CMS_API_URL + `/admin/category/` + category_id + `/medication/` + medication_id + `/refilldiscount`, payload);
  }

  updateRefillDiscount(category_medication_promos_xref_id, payload) {
    return this.$http.put(this.CMS_API_URL + `/admin/refilldiscount/` + category_medication_promos_xref_id, payload);
  }

  listRefillDiscount() {
    return this.$http.get(this.CMS_API_URL + `/admin/refilldiscount`, {
      loadingText: `Loading refill discounts`
    });
  }

}

Discounts.$inject = ["$log", "$http", "Endpoints", "API_URL", "CMS_API_URL"];
angular.module('pims').service('Discounts', Discounts);